/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    Token: '',
    nickName: '',
    group: '',
    login_ok: false
  },
  mutations: {
    add: (state, data) => {
      state.Token = data.token
      state.nickName = data.nickname
      state.group = data.group
    },
    getGroup: (state, data) => {
      state.group = data
    },
    setLoginInfo: (state, data) => {
      state.login_ok = data;
      window.sessionStorage.setItem('login_in_before',data)
    },
    getLoginInfo: (state) => {
      state.login_ok = window.sessionStorage.getItem('login_in_before')
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js